import { Component, Vue, State, namespace, Prop } from 'nuxt-property-decorator'
import { Tour } from '~/types/tour'

const experience = namespace('experience')

@Component
export default class Index extends Vue {
  @State((state) => state.klook.platform) platform!: Data.Platform
  @experience.State tourHomePageBasic!: Tour.VerticalHomePageBasic
  @Prop() placeholder!: string
  @Prop() deepLink!: string
  @Prop() icon!: string

  get isDesktop() {
    return this.platform === 'desktop'
  }

  get genPageSpm() {
    const { predict_country_id, predict_city_id, predict_poi_id } = this.tourHomePageBasic?.track_info || {}
    const ext: any = {}

    if (predict_city_id) {
      ext.city_id = predict_city_id
    }

    if (predict_country_id) {
      ext.country_id = predict_country_id
    }

    if (predict_poi_id) {
      ext.poi_id = predict_poi_id
    }

    return `TNA_SearchStart?trg=manual&ext=${encodeURIComponent(JSON.stringify(ext))}`
  }

  getSpm(type: string) {
    const spmName = type === 'btn' ? 'SearchBtn' : 'TNASearchInput'
    const extra = {
      query: this.tourHomePageBasic.search_placeholder || ''
    }

    return `${spmName}?trg=manual&ext=${encodeURIComponent(JSON.stringify(extra))}`
  }
}
